// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1QLgb","productName":"Table_productName__3PBBs"};